import React from 'react'

const TimesThinIcon = props => (
  <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.92018 1.89186L8.91685 0.888531L5.40527 4.40011L1.8937 0.888531L0.890369 1.89186L4.40195 5.40344L0.890233 8.91515L1.89356 9.91848L5.40527 6.40676L8.91699 9.91848L9.92031 8.91515L6.4086 5.40344L9.92018 1.89186Z"
      fill="currentColor"
    />
  </svg>
)

export default TimesThinIcon
